/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, message } from "antd";
import { Collapse, Form, Flex, Row, Col, Space, Select } from "antd";
import { Input, Button, Table, Typography } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { MdOutlineLibraryAdd } from "react-icons/md";
import { accessColumn } from "./model";
import useColumnSettings from "../../../hooks/useColumnSettings";
import useAccessPageState from '../../../hooks/useAccessPageState';
import Runcodeservice from "../../../service/ERP/Runcode.service";

const runcodeservice = Runcodeservice();
const mngConfig = {
  title: "",
  textOk: null,
  textCancel: null,
  action: "create",
  code: null,
};
const RuncodeAccess = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [accessData, setAccessData] = useState([]);
  const [activeSearch, setActiveSearch] = useState([]);
  const {
    tablePagination,
    saveState,
    restoreState,
    clearState,
    restoreDefaultPagination,
    handleTableChange,
  } = useAccessPageState({ form });

  const handleSearch = (forcedValues = null, paginationOverride = null) => {
    const runSearch = (v) => {
      saveState(v, paginationOverride ?? tablePagination);
      const data = { ...v };
      runcodeservice
        .search(data, { ignoreLoading: Object.keys(data).length !== 0 })
        .then((res) => {
          const { data } = res.data;

          setAccessData(data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Request error!");
        });
    };

    if (useAccessPageState.canUseForcedSearchValues(forcedValues)) {
      runSearch(forcedValues);
      return;
    }

    form.validateFields().then((v) => {
      runSearch(v);
    });
  };

  const handleClear = () => {
    clearState();
    form.resetFields();

    const nextPagination = restoreDefaultPagination();

    handleSearch({}, nextPagination);
  };

  const hangleAdd = () => {
    navigate("manage/create", {
      state: {
        config: {
          ...mngConfig,
          title: "เพิ่มRuncode",
          action: "create",
        },
      },
    });
  };

  const handleEdit = (data) => {
    // setManageConfig({...manageConfig, title:"แก้ไข Sample Request", action:"edit", code:data?.srcode});
    navigate("manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "แก้ไขRuncode",
          action: "edit",
          code: data?.id,
        },
      },
    });
  };

  const handleView = (data) => {
    navigate("manage/view", {
      state: {
        config: {
          ...mngConfig,
          title: "View ระบบ Runcode",
          action: "view",
          code: data?.id,
        },
      },
    });
  };

  const handleDelete = (data) => {
    // startLoading();
    // ctmService.deleted(data?.dncode).then( _ => {
    //     const tmp = accessData.filter( d => d.dncode !== data?.dncode );
    //     setAccessData([...tmp]);
    // })
    // .catch(err => {
    //     console.log(err);
    //     message.error("Request error!");
    // });
  };

  useEffect(() => {
    const restored = restoreState();

    handleSearch(restored?.searchValues ?? null, restored?.tablePagination);
  }, []);

  const getData = (data) => {
    runcodeservice
      .search(data)
      .then((res) => {
        const { data } = res.data;

        setAccessData(data);
      })
      .catch((err) => {
        console.log(err);
        message.error("Request error!");
      });
  };
  const FormSearch = (
    <Collapse
      size="small"
      onChange={(e) => {
        setActiveSearch(e);
      }}
      bordered={false}
      activeKey={activeSearch}
      items={[
        {
          key: "1",
          label: (
            <>
              <SearchOutlined />
              <span> ค้นหา</span>
            </>
          ),
          children: (
            <>
              <br />
              <Form form={form} layout="vertical" autoComplete="off">
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item
                      label="ชื่อนำหน้า"
                      name="prefix"
                      onChange={handleSearch}
                    >
                      <Input placeholder="กรอกชื่อนำหน้า" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item
                      label="Run number"
                      name="run_number"
                      onChange={handleSearch}
                    >
                      <Input placeholder="กรอก Run number" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={8}>
                    <Form.Item label="ประเภทสินค้า" name="product_type">
                      <Select
                        size="large"
                        onChange={handleSearch}
                        options={[
                          { value: "PK", label: "Packaging" },
                          { value: "PC", label: "Packing" },
                          { value: "WI", label: "Work Instruction" },
                          { value: "FG", label: "Finished Goods" },
                          { value: "PG", label: "Packing Goods" },
                          { value: "IG", label: "Ingredient" },
                          { value: "RM", label: "Raw Material" },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    {/* Ignore */}
                  </Col>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    <Flex justify="flex-end" gap={8}>
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        icon={<SearchOutlined />}
                        onClick={() => handleSearch()}
                      >
                        ค้นหา
                      </Button>
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        danger
                        icon={<ClearOutlined />}
                        onClick={() => handleClear()}
                      >
                        ล้าง
                      </Button>
                    </Flex>
                  </Col>
                </Row>
              </Form>
            </>
          ),
          showArrow: false,
        },
      ]}
    />
  );
  const allColumns = accessColumn({ handleEdit, handleDelete, handleView });
  /* คอลัมน์ที่แสดง ผู้ใช้เลือกเองได้ ระบบจำไว้ใน cookie ของเครื่องนี้ */
  const { columns: column, settingsButton } = useColumnSettings(
    "runcode_access_cols",
    allColumns
  );

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            ระบบ Runcode
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={8} justify="end">
          {settingsButton}
          <Button
            size="small"
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<MdOutlineLibraryAdd style={{ fontSize: ".9rem" }} />}
            onClick={() => {
              hangleAdd();
            }}
          >
            เพิ่มRuncode
          </Button>
        </Flex>
      </Col>
    </Flex>
  );
  return (
    <div className="runcode-access">
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex", position: "relative" }}
      >
        {FormSearch}
        <Card>
          <Row gutter={[8, 8]} className="m-0">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Table
                title={() => TitleTable}
                size="small"
                rowKey="runcodecode"
                columns={column}
                dataSource={accessData}
                pagination={tablePagination}
                onChange={handleTableChange}
              />
            </Col>
          </Row>
        </Card>
      </Space>
    </div>
  );
};

export default RuncodeAccess;
